<app-dashboard-shell
  title="Billing Dashboard"
  description="AI activation billing by franchise. Edit monthly rate, included activations, and overage rate directly."
  [lastReload]="lastReload"
  [loading]="loading"
  (refresh)="triggerReload()"
>

  <div class="p-col-12">
    <div class="p-grid">
      <div class="p-col-12 p-md-2">
        <div class="dashboard-card">
          <h6 class="p-mb-0">Total Revenue</h6>
          <p class="p-mb-0 p-mt-1">{{ totals.totalCostBilling | currency:totals.billingCurrency:'symbol':'1.2-2' }}</p>
        </div>
      </div>
      <div class="p-col-12 p-md-2">
        <div class="dashboard-card">
          <h6 class="p-mb-0">Monthly Total</h6>
          <p class="p-mb-0 p-mt-1">{{ totals.monthlyRate | currency:totals.billingCurrency:'symbol':'1.2-2' }}</p>
        </div>
      </div>
      <div class="p-col-12 p-md-2">
        <div class="dashboard-card">
          <h6 class="p-mb-0">Included Activations</h6>
          <p class="p-mb-0 p-mt-1">{{ totals.includedActivations | number }}</p>
        </div>
      </div>
      <div class="p-col-12 p-md-2">
        <div class="dashboard-card">
          <h6 class="p-mb-0">Overages</h6>
          <p class="p-mb-0 p-mt-1">{{ totals.overageCount | number }}</p>
        </div>
      </div>
      <div class="p-col-12 p-md-2">
        <div class="dashboard-card">
          <h6 class="p-mb-0">Overage Revenue</h6>
          <p class="p-mb-0 p-mt-1">{{ totals.overageCost | currency:totals.billingCurrency:'symbol':'1.2-2' }}</p>
        </div>
      </div>
      <div class="p-col-12 p-md-2">
        <div class="dashboard-card">
          <h6 class="p-mb-0">Activations</h6>
          <p class="p-mb-0 p-mt-1">{{ totals.activationCount | number }}</p>
        </div>
      </div>
    </div>
  </div>

  <div class="p-col-12">
    <h5 class="p-mb-1">AI Usage</h5>
    <div class="p-grid">
      <div class="p-col-12 p-md-3">
        <div class="dashboard-card">
          <h6 class="p-mb-0">Total Cost</h6>
          <p class="p-mb-0 p-mt-1">{{ totals.totalCost | currency:'USD':'symbol':'1.2-4' }}</p>
        </div>
      </div>
      <div class="p-col-12 p-md-3">
        <div class="dashboard-card">
          <h6 class="p-mb-0">Cost / Activation</h6>
          <p class="p-mb-0 p-mt-1">{{ totals.costPerActivation | currency:'USD':'symbol':'1.2-4' }}</p>
        </div>
      </div>
      <div class="p-col-12 p-md-3">
        <div class="dashboard-card">
          <h6 class="p-mb-0">Activations / Job</h6>
          <p class="p-mb-0 p-mt-1">{{ totals.activationsPerJob | number:'1.1-1' }}</p>
        </div>
      </div>
    </div>
  </div>

  <div class="p-col-12">
    <div class="dashboard-card">
      <p-table
        [value]="tableData"
        [loading]="loading"
        [scrollable]="true"
        styleClass="p-datatable-sm"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>Franchise</th>
            <th>Monthly Rate</th>
            <th>Included</th>
            <th>Overage Rate</th>
            <th>Overage Revenue</th>
            <th>Total Revenue</th>
            <th>Activations</th>
            <th>Overages</th>
            <th>Tokens</th>
            <th>Cost</th>
            <th>Cost/Act</th>
            <th>Jobs</th>
            <th>Act/Job</th>
            <th>Cost/Job</th>
            <th>Ask Bee</th>
            <th>Outbound</th>
            <th>Inbound</th>
            <th>Sched Comm</th>
            <th>Inv Count</th>
            <th>Inv Cost</th>
            <th>Inv Tokens</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData>
          <tr>
            <td>{{ rowData.zoneName }} <i *ngIf="rowData.saving" class="pi pi-spin pi-spinner" style="font-size:.8em"></i></td>
            <td><input type="number" pInputText [value]="rowData.monthlyRate" style="width:90px" step="0.01" (input)="onMonthlyRateChange(rowData, $any($event.target).value)"></td>
            <td><input type="number" pInputText [value]="rowData.includedActivations" style="width:80px" step="1" (input)="onIncludedActivationsChange(rowData, $any($event.target).value)"></td>
            <td><input type="number" pInputText [value]="rowData.overageRate" style="width:80px" step="0.01" (input)="onOverageRateChange(rowData, $any($event.target).value)"></td>
            <td>{{ rowData.overageCost | currency:rowData.billingCurrency:'symbol':'1.2-2' }}</td>
            <td>{{ rowData.totalCostBilling | currency:rowData.billingCurrency:'symbol':'1.2-2' }}</td>
            <td>{{ rowData.activationCount | number }}</td>
            <td>{{ rowData.overageCount | number }}</td>
            <td>{{ rowData.totalTokens | number }}</td>
            <td>{{ rowData.totalCost | currency:'USD':'symbol':'1.2-4' }}</td>
            <td>{{ rowData.costPerActivation | currency:'USD':'symbol':'1.2-4' }}</td>
            <td>{{ rowData.jobCount | number }}</td>
            <td>{{ rowData.activationsPerJob | number:'1.1-2' }}</td>
            <td>{{ rowData.costPerJob | currency:'USD':'symbol':'1.2-4' }}</td>
            <td>{{ rowData.askBeeCount | number }}</td>
            <td>{{ rowData.outboundCallCount | number }}</td>
            <td>{{ rowData.inboundCallCount | number }}</td>
            <td>{{ rowData.scheduleCommCount | number }}</td>
            <td>{{ rowData.updateInventoryCount | number }}</td>
            <td>{{ rowData.updateInventoryCost | currency:'USD':'symbol':'1.2-4' }}</td>
            <td>{{ rowData.updateInventoryTokens | number }}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="21" class="p-text-center">No billing data for the selected period.</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>

</app-dashboard-shell>
